import React, { useMemo } from 'react';
import { Package, BookOpen, Image, BookMarked, Users, GraduationCap, LayoutDashboard } from 'lucide-react';
import AdminLayout from '../components/admin/AdminLayout';
import ProductsContainer from '../containers/admin/ProductsContainer';
import GuidesContainer from '../containers/admin/GuidesContainer';
import MediaContainer from '../containers/admin/MediaContainer';
import GlossariesContainer from '../containers/admin/GlossariesContainer';
import UsersContainer from '../containers/admin/UsersContainer';
import CoursesContainer from '../containers/admin/CoursesContainer';
import DashboardContainer from '../containers/admin/DashboardContainer';
import { useAuth } from '../contexts/AuthContext';

const allTabs = [
  { id: 'dashboard', label: 'tabs.dashboard', icon: LayoutDashboard, Component: DashboardContainer, isAdminOnly: true },
  { id: 'products', label: 'tabs.products', icon: Package, Component: ProductsContainer },
  { id: 'guides', label: 'tabs.guides', icon: BookOpen, Component: GuidesContainer },
  { id: 'glossaries', label: 'tabs.glossaries', icon: BookMarked, Component: GlossariesContainer },
  { id: 'courses', label: 'tabs.courses', icon: GraduationCap, Component: CoursesContainer },
  { id: 'users', label: 'tabs.users', icon: Users, Component: UsersContainer, isAdminOnly: true },
  { id: 'media', label: 'tabs.media', icon: Image, Component: MediaContainer },
];

const AdminPage: React.FC = () => {
  const { user } = useAuth();

  const filteredTabs = useMemo(() => {
    if (!user) return [];

    // Admin can see all tabs
    if (user.role === 'admin') {
      return allTabs;
    }

    // Creator can see products, guides, glossaries, courses, and media
    if (user.role === 'creator') {
      return allTabs.filter((tab) => ['products', 'guides', 'glossaries', 'courses', 'media'].includes(tab.id));
    }

    return [];
  }, [user]);

  return <AdminLayout tabs={filteredTabs} />;
};

export default AdminPage;
